import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCuQ6FanW9gxMnsPtjjHI2mCYaqEX-Iezw",
  authDomain: "quanlyxudoan.firebaseapp.com",
  projectId: "quanlyxudoan",
  storageBucket: "quanlyxudoan.firebasestorage.app",
  messagingSenderId: "192706440616",
  appId: "1:192706440616:web:e017d038543e62246b019d",
  measurementId: "G-DM78E4W5VF"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Bật cache offline - Firestore Persistence (MIỄN PHÍ)
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Nhiều tab đang mở, persistence chỉ hoạt động trên 1 tab');
  } else if (err.code === 'unimplemented') {
    console.warn('Trình duyệt không hỗ trợ persistence');
  }
});